<template>
  <div>
    <h2>Drug Combinations</h2>
    <br />
    <div class="alert alert-info">
      Additional information to be included in the shed VA/Drug charts sent to clients.
    </div>
    <div v-for="farm in FARMS" :key="`farm_${farm.id}-drugsallocated`">
      <div class="clearfix" :style="{ width: 400 + widthForRow(FARMS) + 'px' }">
        <fieldset>
          <legend>
            <h3> Drugs Allocated <small>({{ farm.farm_label }})</small></h3>
          </legend>
          <ul style="list-style:none" class="text-left">
            <li v-for="(drug, index) in drugsAllocated(farm)" :key="`allocation_${index}`">
              <strong class="text-danger">
                {{drug.name}}
              </strong>
            </li>
          </ul>
        </fieldset>
        <text-area label="Special Instructions or contraindications"
                   :field-name="`farm_${farm.id}-drug_combos_instructions`"
                   subtext="These notes will be included on the antibiotic and anti-inflammatory combinations chart."
                   :disabled="isReadOnly">
        </text-area>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'DrugCombinations',
  mixins: [baseComponent],
  methods: {
    drugsAllocated: function (farm) {
      let GROUPS_TO_SHOW = [1, 5, 6, 7, 15]
      // 1 "Anti-inflammatories NSAIDS"
      // 5 "Injectable Antibiotics"
      // 6 "Injectable Mastitis Treatments"
      // 7 "Intra-Mammaries"
      // 15 "Critically Important Antibiotics"
      let drugsToShow = (this.getFieldValue('drug_groups', 'DrugAllocations') || [])
        .filter((group) => GROUPS_TO_SHOW.includes(group.pk))
        .map((group) => group.drugs)
        .flat()
        .map((drug) => { return {pk: drug.pk, name: drug.name}})

      return ((this.getFieldValue('drugs_allocated', 'DrugAllocations') || {})[farm.id] || []).reduce(
        (allocatedDrugs, currentAllocation) => {
          let drug = drugsToShow.find(drug => drug.pk == currentAllocation.drug_allocation_product)
          if (drug) { allocatedDrugs.push(drug)}
          return allocatedDrugs
        }, [])
    },
  },
}
</script>
